<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/otnMoI/tc-custom/9781626819054.jpg?1703853942933" alt="This image is the cover for the book Lady and the Outlaw, The Kincaid Family Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lady and the Outlaw, The Kincaid Family Series
      </h1>
      <p class="bookDescription body article font2">
        <b>When a Wild West bandit takes an educated young woman hostage, the sparks that fly between them are more dangerous than bullets—“Don’t miss this one!” (<i>Affaire de Coeur</i>, 5 stars).</b><br/>  <br/> A recent graduate of Wellesley College, Leslie Powers is on her way out to Arizona Territory. All she knows about the frontier comes from pulp magazines. But she’s about to get a wild education in the way of the West when Ward Cantrell, the leader of the Devil’s Canyon Gang, takes her hostage. With every reason to hate the rakishly handsome rogue, Leslie finds herself falling desperately in love with him.<br/>  <br/> Ward has good reasons for preying on the Kinkaid family’s Texas and Pacific railroad—reasons that reach back to a secret, former life. He doesn’t normally let emotions get in the way of his work, but could his beautiful captive be spellbinding enough to make him forget his old grudges?<br/>  <br/> “Wonderful! Bold, charming, and complete. The dialogue sparkles, the characters are truly alive and vibrant, and there is a sensitivity in the entire mood of the story . . . Don’t miss this one, it is pure joy!” —<i>Affaire de Coeur</i>, RWA Golden Medallion finalist
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joyce Brandon
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f984d4ac